<template lang="html">
  <section class="section">
    <div class="container">

      <h1 class="title has-text-secondary">Help & FAQ</h1>
          <h2 class="subtitle is-italic is-size-6">
            This section summarizes questions frequently asked and their corresponding answers.<br>
            If you don't find what you're searching for, don't hesitate to let us know at <a>contact@costuto.com</a>
          </h2>

      <div class="columns">
        <div class="column is-2">

          <b-menu>

            <b-menu-list label="User">
              <b-menu-item @click="activeQa = ['registration', 'accountData']" icon="account" label="Account">
                <b-menu-item @click="activeQa = ['registration']" label="Registration"></b-menu-item>
                <b-menu-item @click="activeQa = ['accountData']" label="Account data"></b-menu-item>
              </b-menu-item>

              <b-menu-item icon="folder-multiple-outline" label="Projects">
                <b-menu-item label="Content published"></b-menu-item>
                <b-menu-item label="Project"></b-menu-item>
                <b-menu-item label="Craft"></b-menu-item>
                <b-menu-item label="Article"></b-menu-item>
                <b-menu-item label="Purchase"></b-menu-item>
              </b-menu-item>
            </b-menu-list>

            <b-menu-list label="Interactions">
              <b-menu-item @click="activeQa = 'teacher'" icon="teach" label="Teacher"></b-menu-item>
              <b-menu-item @click="activeQa = 'student'" icon="glasses" label="Student"></b-menu-item>
              <b-menu-item  @click="activeQa = 'saveSystem'" icon="heart-outline" label="Save system"></b-menu-item>
            </b-menu-list>

            <b-menu-list label="Other">
              <b-menu-item icon="cart" label="Sponsors"></b-menu-item>
            </b-menu-list>
          </b-menu>

        </div>
        <div class="column">

          <div class="columns is-multiline">
            <div class="column is-full">
                <div v-for="qa in currentQa" :key="qa.question" class="box">
                  <p><strong><b-icon size="is-small" icon="comment-question-outline"></b-icon> {{ qa.question }}</strong> </p>
                  <p class="has-text-justified"><b-icon size="is-small" icon="chevron-double-right"></b-icon>
                    {{ qa.answer }}
                  </p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  data () {
    return {
      activeQa: ['registration', 'accountData'],
      qa: {
        accountData: [
          {
            question: 'Ok?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        registration: [
          {
            question: 'What are the requirements to register ?',
            answer: 'You should be at least 13 years old.'
          }
        ],
        saveSystem: [
          {
            question: 'Why no like system ?',
            answer: "We strongly believe that a comment worths more than 10k likes. Likes can often be a source of anxiety for many Cosplayers. By experience, we've observed that receiving \"likes\" is not as positive as it's supposed to be. Beginners might feel sad of the lack of likes, while an acknowledged one keeps an eye on the counter to make sure it doesn't get lower than the previous post. At Costuto, we promote positive-attitude, well-being and thus encourage a more personal way to support and cheer your favorite Cosplayers !"
          }
        ]
      }
    }
  },
  computed: {
    currentQa () {
      return this.activeQa.reduce((acc, currentVal) => acc.concat(this.qa[currentVal]), [])
    }
  }
}
</script>

<style lang="css" scoped>
</style>
